import { RootState } from 'redux/store';

export const selectfavoriteDiscountsIds = (state: RootState) =>
  state.favorites.favoriteDiscountsIds;

export const selectFavoriteDiscountsData = (state: RootState) =>
  state.favorites.favoriteDiscountsData;

export const selectFavoritesLoading = (state: RootState) =>
  state.favorites.loading;

export const selectFavoritesError = (state: RootState) => state.favorites.error;

export const selectFavoritesHasMore = (state: RootState) =>
  state.favorites.hasMore;

export const selectFavoritesIsInitialLoad = (state: RootState) =>
  state.favorites.isInitialLoad;
